import './App.css';
import QRcode from './QRcode.jsx';

function App() {
  return (
    <div className="App">
      <QRcode />
    </div>
  );
}

export default App;
